import { gql, TypedDocumentNode } from '@common/hooks';

export const DeleteDetailItemAttachmentMutation: TypedDocumentNode<
  DeleteDetailItemAttachmentMutationResponse,
  DeleteDetailItemAttachmentMutationArgs
> = gql`
  mutation DeleteDetailItemAttachmentMutation($detailItemAttachmentId: ID!) {
    deleteDetailItemAttachment(
      detailItemAttachmentId: $detailItemAttachmentId
    ) {
      success
    }
  }
`;

type DeleteDetailItemAttachmentMutationArgs = {
  detailItemAttachmentId: string;
};

type DeleteDetailItemAttachmentMutationResponse = {
  detailItemAttachmentId: string;
  success: boolean;
};
